import { useState } from 'react';
import { Badge, Card, CardActions, CardHeader, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import DropdownCaretIcon from 'common/icons/dropdown-caret';

import CardTitle from './card-title';

const useStyles = makeStyles(() => ({
  assetCard: {
    height: 65,
    maxWidth: 400,
    minWidth: 250,
    borderBottom: '2px solid #44D2F2',
    marginBottom: 0,
  },
  cardHeader: {
    textAlign: 'left',
    padding: 0,
    margin: 0,
  },
  cardAvatar: {
    width: 50,
    height: 50,
    marginRight: 8,
  },
  assertIcon: {
    transform: 'scale(0.85)',
  },
  cardAction: {
    margin: 'auto',
    height: 65,
    display: 'flex',
    alignItems: 'center',
    marginLeft: 8,
    paddingRight: 12,
  },
  btnExpand: {
    padding: '5px 5px 0px 0px',
    transform: 'rotate(0deg)',
  },
  btnShrink: {
    transform: 'rotate(180deg)',
    padding: '5px 0px 0px 5px',
  },
  cardContent: {
    height: 0,
    maxWidth: 400,
    minWidth: 400,
    overflow: 'hidden',
    backgroundColor: '#fff',
    borderRadius: '0px 0px 2% 2%',
    transition: 'height ease 0.2s',
  },
  showContent: {
    height: 'auto',
  },
  assetList: {
    padding: 0,
    marginLeft: 5,
    marginRight: 5,
  },
  badge: {
    userSelect: 'none',
  },
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AssetCard = (props: any) => {
  const [isExpanded, setIsExpanded] = useState(props.isExpanded);
  const classes = useStyles();

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <Card className={classes.assetCard} data-cy={`asset-card-${props.title}`}>
        <CardHeader
          avatar={
            props.badgeCount !== undefined && (
              <div>
                <img className={classes.assertIcon} src={props.img} alt="" />
              </div>
            )
          }
          action={
            <Badge
              className={classes.badge}
              color="primary"
              badgeContent={props.badgeCount}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              invisible={props.badgeCount ? false : true}
            >
              <IconButton
                className={clsx(classes.btnExpand, { [classes.btnShrink]: isExpanded })}
                onClick={handleExpandClick}
                size="large"
              >
                <DropdownCaretIcon width="19" height="13" fillColor="black" />
              </IconButton>
            </Badge>
          }
          // This is required to remove override styles
          classes={{ avatar: classes.cardAvatar, action: classes.cardAction }}
          className={clsx(classes.cardHeader, classes.cardAction)}
          titleTypographyProps={{ variant: 'h5' }}
          title={<CardTitle title={props.title} subtitle={props.subtitle} />}
        ></CardHeader>
        <CardActions className={classes.cardAction} disableSpacing></CardActions>
      </Card>
      <div className={clsx(classes.cardContent, { [classes.showContent]: isExpanded })}>
        <div>
          <ul className={classes.assetList}>{props.children}</ul>
        </div>
      </div>
    </div>
  );
};

export default AssetCard;
